import React from "react"
import { useSelector } from "react-redux"
import { formSubmissionData } from "reduxSlices/formSubmissionSlice"
import { useFormSubmissionFormContext } from "contexts/FormSubmissionFormContext"
import { AnsweredFormOverview } from "shared/form"

const FORM_SUBMISSION_DELETED_QUESTIONS_NOTE = "The following questions were removed from the form after this submission was created."

const SubmissionOverview = () => {
  const { deletedQuestions, inFocusFormVersion, newQuestions } = useFormSubmissionFormContext()
  const { sections } = inFocusFormVersion

  const { answers } = useSelector(formSubmissionData)

  const newQuestionUuids = newQuestions.map((question) => question.uuid)

  return (
    <div className="relative">
      <AnsweredFormOverview
        answers={answers}
        deletedQuestionsNote={FORM_SUBMISSION_DELETED_QUESTIONS_NOTE}
        deletedQuestions={deletedQuestions}
        newQuestionUuids={newQuestionUuids}
        sections={sections}
      />
    </div>
  )
}

export default SubmissionOverview
